export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10921.d1ef98e0.jpg";